import { UndergradModule } from '@/models/undergrad/undergrad-module.model';

export interface UndergradSubmoduleState {
  undergradSubmodules: { [key: string]: UndergradModule };
}

const state: UndergradSubmoduleState = {
  undergradSubmodules: {},
};

export default state;
